import React, {useState} from "react";
import axios from "axios";
import "../styles/TermCreateForm.css";

export default function TermCreateForm() {
    const [form, setForm] = useState({
        name: "",
        code: "",
        startDate: "",
        endDate: "",
        recordStartDate: "",
        recordEndDate: "",
        status: "aktif",
        participantType: "öğrenci",
        participantCount: 0,
        minParticipantCount: 10,
        maxParticipantCount: 100
    });

    const handleChange = (e) => {
        const {name, value} = e.target;
        setForm({...form, [name]: value});
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post(`${process.env.REACT_APP_API_URL}/terms`, form)
            .then(() => alert("Dönem başarıyla eklendi!"))
            .catch((err) => alert("Hata: " + err.message));
    };

    return (
        <form onSubmit={handleSubmit} className="term-create-form">
            <h2>Yeni Dönem Ekle</h2>
            <label htmlFor="name">Dönem Adı</label>
            <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
            />
            <label htmlFor="code">Dönem Kodu</label>
            <input
                type="text"
                name="code"
                value={form.code}
                onChange={handleChange}
                required
            />
            <label htmlFor="startDate">Başlangıç Tarihi</label>
            <input
                type="date"
                name="startDate"
                value={form.startDate}
                onChange={handleChange}
                required
            />
            <label htmlFor="endDate">Bitiş Tarihi</label>
            <input
                type="date"
                name="endDate"
                value={form.endDate}
                onChange={handleChange}
                required
            />
            <label htmlFor="recordStartDate">Kayıt Başlangıç Tarihi</label>
            <input
                type="date"
                name="recordStartDate"
                value={form.recordStartDate}
                onChange={handleChange}
                required
            />
            <label htmlFor="recordEndDate">Kayıt Bitiş Tarihi</label>
            <input
                type="date"
                name="recordEndDate"
                value={form.recordEndDate}
                onChange={handleChange}
                required
            />
            <label htmlFor="status">Durum</label>
            <select name="status" value={form.status} onChange={handleChange}>
                <option value="aktif">Aktif</option>
                <option value="pasif">Pasif</option>
            </select>
            <label htmlFor="participantType">Katılımcı Tipi</label>
            <select name="participantType" value={form.participantType} onChange={handleChange}>
                <option value="öğrenci">Öğrenci</option>
                <option value="eğitmen">Halk</option>
            </select>
            <label htmlFor="participantCount">Katılımcı Sayısı</label>
            <input
                type="number"
                name="participantCount"
                value={form.participantCount}
                onChange={handleChange}
                min="0"
            />
            <label htmlFor="minParticipantCount">Min Katılımcı</label>
            <input
                type="number"
                name="minParticipantCount"
                value={form.minParticipantCount}
                onChange={handleChange}
                min="0"
            />
            <label htmlFor="maxParticipantCount">Max Katılımcı</label>
            <input
                type="number"
                name="maxParticipantCount"
                value={form.maxParticipantCount}
                onChange={handleChange}
                min="0"
            />
            <button type="submit">Kaydet</button>
        </form>
    );
}
